var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.ready)?_c('line-chart',{attrs:{"css-classes":"lk_switch_graf","chart_data":_vm.chart_data,"options":_vm.chart_options}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }